module.exports = __webpack_public_path__ + "img/support3.724ea243.jpg";